import PropTypes from 'prop-types'
import ArrowRight from 'baseui/icon/arrow-right'
import IconCheckCircle from '@/shared/icons/NewDesign/IconCheckCircle'
import { Button } from 'baseui/button'
import ScheduleCallbackForm from './ScheduleCallbackForm'
import useScheduleCallback from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/useScheduleCallback'
import { useTranslation } from 'react-i18next'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import ScheduleCalendarButton from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCalendarButton'
import {
  ModalLayout,
  Title,
  Subtitle,
  SuccessContainer,
  SuccessMessage,
} from './styled-components'
import useScheduleCallbackValidation from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/useScheduleCallbackValidation'

const ScheduleCallbackModalContent = ({version}) => {
  const { t } = useTranslation()
  useScheduleCallbackValidation()
  const {
    success,
    message,
    isLoading,
    isValid,
    schedule,
    hasUpcoming,
    hourOptions,
    minuteOptions,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phone,
    setPhone,
    email,
    setEmail,
    assigned,
    date,
    setDate,
    hour,
    setHour,
    minutes,
    setMinutes,
    googleCalendarUrl,
    setAssigned
  } = useScheduleCallback(version)

  const values = {
    firstName,
    lastName,
    phone,
    email,
    date,
    hour,
    minutes,
    assigned,
  }

  const handlers = {
    setFirstName,
    setLastName,
    setPhone,
    setEmail,
    setDate,
    setHour,
    setMinutes,
    setAssigned,
  }

  const selects = { hourOptions, minuteOptions }

  if (success) {
    return (
      <SuccessContainer>
        <IconCheckCircle size={80} color="green" />
        <SuccessMessage>{message || t('common:action_completed')}</SuccessMessage>
        <ScheduleCalendarButton googleCalendarUrl={googleCalendarUrl} />
      </SuccessContainer>
    )
  }

  return (
    <ModalLayout>
      <Title>
        {t('subscriptionTools:schedule_callback.module_title')}
      </Title>
      <SDNotification
        type='info'
        primaryText={t('subscriptionTools:schedule_callback.already_scheduled_callback')}
        hidden={!hasUpcoming}
      />
      <ScheduleCallbackForm
        t={t}
        values={values}
        handlers={handlers}
        selects={selects}
        hasUpcoming={hasUpcoming}
      />
      <Subtitle>{t('subscriptionTools:schedule_callback.info_note')}</Subtitle>
      <Button
        size="compact"
        kind="primary"
        disabled={isLoading || !isValid || hasUpcoming}
        isLoading={isLoading}
        onClick={schedule}
        endEnhancer={() => <ArrowRight size={15} />}
      >
        {t('subscriptionTools:schedule_callback.schedule_button')}
      </Button>
    </ModalLayout>
  )
}

ScheduleCallbackModalContent.propTypes = {
  version: PropTypes.string,
}

export default ScheduleCallbackModalContent
